import { guideSteps, services } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

const toneMap: Record<string, string> = {
  primary: { bubble: "bg-primary-100 text-primary-600", chip: "bg-primary-500" },
  accent: { bubble: "bg-accent-100 text-accent-600", chip: "bg-accent-500" },
};

export default function ServiceHub() {
  return (
    <section id="services" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6 lg:px-8">
        <SectionHeading
          eyebrow="一站式吃瓜服务"
          title="蹲后续、催更、指路，全都安排上"
          desc="不知道瓜从哪吃起？这里把入口、进度和名场面都整理好，围观体验更省心。"
        />

        {/* services cards */}
        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {services.map((s) => {
            const tone = toneMap[s.accent];
            return (
              <article
                key={s.title}
                className="group rounded-2xl border border-background-200 bg-background-50 p-6 transition-transform duration-300 hover:-translate-y-1"
              >
                <div className={`flex h-12 w-12 items-center justify-center rounded-xl ${tone.bubble}`}>
                  <i className={`${s.icon} text-2xl`}></i>
                </div>
                <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{s.title}</h3>
                <p className="mt-2 text-sm leading-6 text-foreground-600">{s.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-primary-600 group-hover:text-primary-700">
                  <i className={`${tone.chip} inline-block h-1.5 w-1.5 rounded-full`}></i>
                  已上线
                </span>
              </article>
            );
          })}
        </div>

        {/* four steps band */}
        <div className="mt-12 rounded-3xl bg-background-100 px-6 py-8 md:px-10 md:py-10">
          <h3 className="text-center font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            新手吃瓜不迷路 · 四步走
          </h3>
          <ol className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {guideSteps.map((g) => (
              <li key={g.step} className="flex flex-col rounded-2xl bg-background-50 p-5">
                <span className="font-heading text-2xl font-bold text-accent-400">{g.step}</span>
                <h4 className="mt-3 font-heading text-base font-bold text-foreground-950">{g.title}</h4>
                <p className="mt-2 text-sm leading-6 text-foreground-600">{g.desc}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}